<template>
    <page>
        <module title="预售活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>
                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>
                    <c-detail-item label="预售类型">{{presellTypeMap[activityInfo.presell_type]}}</c-detail-item>
                    <c-detail-item label="定金比例">
                      <span v-if="activityInfo.presell_type == 1">
                           {{activityInfo.prepayment_ratio}}%
                      </span>
                      <span v-else> -- </span>
                    </c-detail-item>
                    <c-detail-item label="支付尾款时间">
                      <span v-if="activityInfo.presell_type == 1">
                           {{activityInfo.balance_begin_date}} - {{activityInfo.balance_end_date}}
                      </span>
                    <span v-else> -- </span>
                    </c-detail-item>
                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>
                    <c-detail-item label="可售范围">{{activityInfo.visible_user_level_name}}</c-detail-item>
                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="250"
                            >
                                <template v-slot="{data}">
                                    <product-info :image="data.product_img_url" :name="(data.product_itemnumber||'') + ' ' + data.product_name"></product-info>
                                </template>
                            </c-table-column>

                            <c-table-column
                                label="商品货号"
                                name="product_itemnumber"
                                width="100"
                            ></c-table-column>

                            <c-table-column
                                    label="价格"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                          <c-table-column
                              label="活动折扣"
                              width="140"
                              name="activity_discount"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.activity_discount">{{ data.activity_discount }}折</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="促销价"
                              name="promotion_price"
                              width="80"
                          >
                            <template v-slot="{data}">
                                    <span v-if="data.activity_discount">
                                     ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
                                      </span>
                                    </span>
                            </template>
                          </c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_presell_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: '',
                productList: [],
                presellTypeMap: {'1':'定金','2':'全款'},
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activityPresell/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
                    }
                });
          }
        }
    }
</script>